import { render } from "./MedeaFooter.vue?vue&type=template&id=ba5dd0a8"
import script from "./MedeaFooter.vue?vue&type=script&lang=js"
export * from "./MedeaFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__